'use strict'

module.exports = [
    '$scope',
    '$mdDialog',
    'count',
    'option',
    ($scope, $mdDialog, count, option) => {

        $scope.cancel = data => $mdDialog.cancel(data)
        $scope.ok = data => $mdDialog.hide(data)
        $scope.option = () => {}

        $scope.count = count
        $scope.option = option

        $scope.radioModel = 'moveItems'

    }
]
